import { useModalObject } from '@wecasa/common/src/hooks/use-modal';

import { translate } from '@wecasa/i18n';

import Separator from '@wecasa/web-ui/src/components/separator/separator';

import WhatIsInstantTaxCreditModal from '../../../../../../tax-credit-modals/what-is-instant-tax-credit-modal';
import WhatIsTaxCreditModal from '../../../../../../tax-credit-modals/what-is-tax-credit-modal';
import { PriceLine, PriceLineTextButton } from './price-line';

const t = translate('basket');

type PriceLinesProps = {
  formattedTaxAmount: string;
  formattedTotalPrice: string;
  formattedPriceAfterTax: string;
  isITCSelectedOrSuccessfullyPaired: boolean;
  isLoading: boolean;
  shouldShowTaxCreditLines: boolean;
};

export const PriceLines = ({
  formattedTaxAmount,
  formattedTotalPrice,
  formattedPriceAfterTax,
  isITCSelectedOrSuccessfullyPaired,
  isLoading,
  shouldShowTaxCreditLines,
}: PriceLinesProps) => {
  const whatIsInstantTaxCreditModal = useModalObject();
  const whatIsTaxCreditModal = useModalObject();

  if (!shouldShowTaxCreditLines) {
    return (
      <>
        <Separator />
        <PriceLine text={t('.total')} price={formattedTotalPrice} isLoading={isLoading} />
      </>
    );
  }

  if (isITCSelectedOrSuccessfullyPaired) {
    return (
      <>
        <WhatIsInstantTaxCreditModal
          isOpen={whatIsInstantTaxCreditModal.isOpen}
          onClose={whatIsInstantTaxCreditModal.close}
        />

        <Separator />
        <PriceLine text={t('.subtotal')} price={formattedTotalPrice} isPriceStrikedOut isLoading={isLoading} />
        <Separator />
        <PriceLineTextButton
          text={t('.cleaning.services.tax.label_itc')}
          price={formattedTaxAmount}
          onPress={whatIsInstantTaxCreditModal.open}
          isLoading={isLoading}
        />
        <Separator />
        <PriceLine text={t('.total')} price={formattedPriceAfterTax} isBold isLoading={isLoading} />
      </>
    );
  }

  return (
    <>
      <WhatIsTaxCreditModal isOpen={whatIsTaxCreditModal.isOpen} onClose={whatIsTaxCreditModal.close} />

      <Separator />
      <PriceLine text={t('.total')} price={formattedTotalPrice} isLoading={isLoading} />
      <Separator />
      <PriceLineTextButton
        text={t('.cleaning.services.tax.label')}
        price={formattedTaxAmount}
        onPress={whatIsTaxCreditModal.open}
        isLoading={isLoading}
      />
      <Separator />
      <PriceLine text={t('.after_tax_credit')} price={formattedPriceAfterTax} isBold isLoading={isLoading} />
    </>
  );
};
